import React from 'react';
import image from './textImage.png';
import css from './JoinSection.module.css';

const JoinSection = () => {
  const contentRef = React.useRef(null);
  const imageRef = React.useRef(null);

  React.useEffect(() => {
    const elements = [
      { ref: contentRef, factor: 0.06, clampPx: 50 },
      { ref: imageRef, factor: 0.1, clampPx: 70 },
    ].filter((e) => e.ref.current);

    if (elements.length === 0) return undefined;

    const prefersReducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) return undefined;

    let rafId;
    const state = elements.map(() => ({ current: 0, target: 0 }));

    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

    const updateTargets = () => {
      elements.forEach((item, index) => {
        const el = item.ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const t = clamp(rect.top * item.factor, -item.clampPx, item.clampPx);
        state[index].target = t;
      });
    };

    const animate = () => {
      elements.forEach((item, index) => {
        const el = item.ref.current;
        if (!el) return;
        const s = state[index];
        s.current += (s.target - s.current) * 0.12; // easing towards target
        el.style.transform = `translateY(${s.current}px)`;
      });
      rafId = window.requestAnimationFrame(animate);
    };

    const onScrollOrResize = () => {
      updateTargets();
    };

    updateTargets();
    rafId = window.requestAnimationFrame(animate);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    return () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      elements.forEach((item) => {
        if (item.ref.current) item.ref.current.style.transform = '';
      });
    };
  }, []);

  return (
    <div className={css.wrapper}>
      <div ref={contentRef} className={css.contentBox}>
        <p className={css.title}>Join our creator community</p>
        <p className={css.description}>
          ScanWow is more than a store—it's a place to learn, share, and grow alongside other
          makers.
        </p>
        <ul>
          <li>
            Get featured in <b>scan stories</b>
          </li>
          <li>
            Chat in our <b>online communities</b>
          </li>
          <li>
            Learn tips in our growing <b>Knowledge Hub</b>
          </li>
          <li>Discover how others use your scans in wild, wonderful ways!</li>
        </ul>

        <a className={css.cta} href={'/'}>
          <span>{'Visit Our Knowledge Center'}</span>
        </a>
      </div>
      <div ref={imageRef} className={css.imageWrapper}>
        <img className={css.image} src={image} />
      </div>
    </div>
  );
};

export default JoinSection;
